import { useParams } from "react-router-dom";
import { Edit } from "../../../../components/users/Edit.tsx";

export default function UserEditPage() {
  const params = useParams();

  return (
    <div className="w-full h-full p-8 overflow-hidden">
      <Edit id={params.id!} />
    </div>
  );
}
